import React from "react";
import { Container, Box, Typography, Grid, withStyles } from "@material-ui/core";
import LandingCard from "../utils/LandingCard";

const styles = theme => ({
  bold: {
    color: theme.palette.common.black,
    fontWeight: "500",
    align: "center",
  },
  boldGray: {
    color: theme.palette.grey[700],
    fontWeight: "500",
    align: "center",
  },
  textSection: {
    textAlign: "center",
    [theme.breakpoints.up("sm")]: {
      paddingTop: theme.spacing(8),
      marginLeft: theme.spacing(8),
      marginRight: theme.spacing(8),
    },
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(2),
  },
  sectionFour: {
    textAlign: "center",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(4),
  },
});

const Features = ({ title, subtitle, items, classes }) => (
  <Container component='section' py={2}>
    <Box className={classes.textSection}>
      <Typography variant="h3" className={classes.bold} align="center">
        <strong>{title}</strong>
      </Typography>
      <Typography
        variant="h6"
        paragraph
        className={classes.boldGray}
        align="center"
      >
        {subtitle}
      </Typography>
    </Box>
    <Box className={classes.sectionFour}>
      <Grid container spacing={4}>
        {items.map((item, index) => (
          <Grid item md={4} sm={6} key={item.name}>
            <LandingCard
              icon={item.icon || (index + 1)}
              header={item.name}
              children={item.text}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  </Container>
);

export default withStyles(styles)(Features);
